// extracted by mini-css-extract-plugin
export default {"container":"TextCloze_container__Npxot","hotspot":"TextCloze_hotspot__8DQ3B","button":"TextCloze_button__KnskU"};